<template>
  <transition-group name="toasts" tag="div" :class="['c-toasts', 'c-toasts--top-right', isRepositioned]">
    <toast class="toasts-item" v-for="toast in toasts" :toast="toast" :key="toast.id"></toast>
  </transition-group>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex';

  // Components
  import toast from './Toast.vue';

  // Utilities
  import { watchScroll } from '@/utilities';

  export default {
    name: 'Toasts',
    
    components: {
      toast
    },

    data () {
      return {
        scrollState: new watchScroll()
      }
    },

    computed: {
      ...mapGetters([
        'toasts'
      ]),

      isRepositioned () {
        return this.scrollState.scrollingDown ? 'is-repositioned' : '';
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/toasts/Toasts.vue